// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__erXYD","range":"MonthRangeSwitch_range__1suK9","disabled":"MonthRangeSwitch_disabled__3BUUq"};